import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StoreListItem } from "@/types/filters";

import {
  faHouseChimneyMedical,
  faTennisBall,
  faCircleParking,
  faCapsules,
  faStore
} from "@fortawesome/pro-solid-svg-icons";
import { FilterDataProps } from "@/types/filters";
import { BanhoTosa, PersonalPetIcon } from "@/utils/svg";

export const filterDataInitial: FilterDataProps = {
  state: "",
  city: "",
  neighborhood: "",
  facilidades: [],
  zipcode: "",
  filterBy: "address"
};

export const sliderSettings = {
  className: "slider variable-width",
  dots: false,
  infinite: false,
  variableWidth: true,
  swipeToSlide: true,
  slidesToScroll: 3,
  slidesToShow: 6,
  responsive: [
    {
      breakpoint: 1215,
      settings: {
        slidesToShow: 5
      }
    },
    {
      breakpoint: 960,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 830,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 2
      }
    }
  ]
};

export const chips = [
  {
    icon: BanhoTosa,
    title: "Banho e Tosa",
    tags: ["Banho e Tosa"]
  },
  {
    icon: <FontAwesomeIcon icon={faHouseChimneyMedical} fontSize={18} />,
    title: "Clínica Veterinária",
    tags: ["Clínica Veterinária", "Veterinário"]
  },
  {
    icon: PersonalPetIcon,
    title: "Personal Pet",
    tags: ["Personal Pet"]
  },
  {
    icon: <FontAwesomeIcon icon={faTennisBall} fontSize={20} />,
    title: "Pet Park",
    tags: ["Pet Park"]
  },
  {
    icon: <FontAwesomeIcon icon={faCircleParking} fontSize={20} />,
    title: "Estacionamento",
    tags: [
      "Estacionamento",
      "Estacionamento coberto/gratuito",
      "Estacionamento coberto/pago",
      "Estacionamento descoberto/gratuito",
      "Estacionamento descoberto/pago"
    ]
  },
  {
    icon: <FontAwesomeIcon icon={faCapsules} fontSize={18} />,
    title: "Farmácia Veterinária",
    tags: ["Farmácia Veterinária"]
  },
  {
    icon: <FontAwesomeIcon icon={faStore} fontSize={18} />,
    title: "Retire na loja",
    tags: ["Retire na loja", "Retire na loja em até 45 minutos"]
  }
];

// Retorna as opções de estados em ordem alfabética
export const getStatesOptions = (
  storeListData: StoreListItem[]
): { value: string; label: string }[] => {
  if (!storeListData || storeListData.length === 0) {
    return [];
  }

  const states = storeListData.map(({ address }) => address.state.trim());
  const uniqueStates = Array.from(new Set(states));
  const sortedStates = uniqueStates.sort((a, b) => a.localeCompare(b));
  const stateOptions = sortedStates.map((state) => ({
    value: state,
    label: state
  }));
  return stateOptions;
};

// Retorna as opções de cidades de acordo com o estado selecionado em ordem alfabética
export const getCitiesOptions = (
  storeListData: StoreListItem[],
  state: string
): { value: string; label: string }[] => {
  if (!storeListData || storeListData.length === 0) {
    return [];
  }

  const cities = storeListData
    .filter(({ address }) => address.state === state)
    .map(({ address }) => address.city.trim());
  const uniqueCities = Array.from(new Set(cities));
  const sortedCities = uniqueCities.sort((a, b) => a.localeCompare(b));
  const cityOptions = sortedCities.map((city) => ({
    value: city,
    label: city
  }));
  return cityOptions;
};

// Retorna as opções de bairros de acordo com o estado e cidade selecionados em ordem alfabética
export const getNeighborhoodsOptions = (
  storeListData: StoreListItem[],
  state: string,
  city: string
): { value: string; label: string }[] => {
  if (!storeListData || storeListData.length === 0) {
    return [];
  }

  const neighborhoods = storeListData
    .filter(({ address }) => address.state === state && address.city === city)
    .map(({ address }) => address.neighborhood.trim());

  const uniqueNeighborhoods = Array.from(new Set(neighborhoods));

  const sortedNeighborhoods = uniqueNeighborhoods.sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: "base" })
  );

  const neighborhoodOptions = sortedNeighborhoods.map((neighborhood) => ({
    value: neighborhood,
    label: neighborhood
  }));

  return neighborhoodOptions;
};
